import axios from 'axios';

/**
 * @param {import('axios').AxiosRequestConfig} config
 */
export const sessionInterceptor = (config) => {
    try {
        // Prefer token from URL if present; persist for later navigations
        let token = null;
        if (typeof window !== 'undefined') {
            const params = new URLSearchParams(window.location.search);
            token = params.get('token');
            if (token) {
                try {
                    window.sessionStorage.setItem('x-session-token', token);
                } catch (_) {}
            } else {
                try {
                    token =
                        window.sessionStorage.getItem('x-session-token') ||
                        window.localStorage.getItem('x-session-token');
                } catch (_) {}
            }
        }

        if (token) {
            config.headers['x-session-token'] = token;
        }
    } catch (_) {
        // noop – leave header unset if anything goes wrong
    }
    return config;
};

export const apiClient = axios.create({
    baseURL: '/api',
});

export const apiFetcher = (url) => apiClient.get(url).then((res) => res.data);

apiClient.interceptors.request.use(sessionInterceptor);
